import "./App.css";
import Weather from "./Weather";
function App() {
  return (
    <div className="App">
      <Weather city="Los Angeles" />
    </div>
  );
}

export default App;
